// extracted by mini-css-extract-plugin
export default {"horizontalSeparator":"RelevanceTools_horizontalSeparator__z2Tau","grid":"RelevanceTools_grid__JpYaV"};